// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeFilledSvg from "@ant-design/icons-svg/es/asn/DislikeFilled";
import AntdIcon from '../components/AntdIcon';

var DislikeFilled = function DislikeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeFilledSvg
  }));
};

DislikeFilled.displayName = 'DislikeFilled';
export default React.forwardRef(DislikeFilled);